export default defineAppConfig({
  ui: {
    colors: {
      primary: 'indigo',
      info: 'indigo',
      admin: 'pink',
    },
  }
})
